// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__141fe","footer":"ModalInfo_footer__1WHCk"};